
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ChromeOSInstructions',
    data: () => ({
    }),
});

